
	/* eslint-disable max-lines */
	import Vue, { PropType } from 'vue';
	import Component from 'vue-class-component';

	import { CollectionValue, Form } from '@/types';
	import { Refs } from '@cnamts/vue-dot/src/types';
	import { mdiClose, mdiPlus } from '@mdi/js';
	import getRules from '@/mixins/ValidationRules';
	import formatDate from '@/services/Formatter/DateFormatter';
	import getFormValue from '@/functions/getFormValue';
	import CustomFormBuilder from './CustomFormBuilder.vue';

	const Props = Vue.extend({
		props: {
			collectionForm: {
				type: Object as PropType<Form>,
				required: true
			},
			label: {
				type: String,
				required: false,
				default: ''
			},
			btnLabel: {
				type: String,
				required: false,
				default: ''
			},
			/** The v-model value */
			value: {
				type: Array as PropType<Array<CollectionValue>>,
				default: () => []
			},
			apiErrors: {
				type: [Array, Object],
				required: false,
				default: () => []
			},
			formName: {
				type: String,
				default: ''
			}
		}
	});

	@Component<CollectionTypeForm>({
		mixins: [
			getRules
		],
		model: {
			prop: 'value',
			event: 'change'
		},
		watch: {
			apiErrors: {
				handler(newErrors) {
					const itemsCount = newErrors?.[this.formName]?.children?.length || 0;

					for (let i = 0; i < itemsCount; i++) {
						this.applyErrors(i);
					}
				},
				deep: true
			}
		}
	})
	export default class CollectionTypeForm extends Props {
		$refs!: Refs<{
			form: HTMLFormElement;
		}>;

		collectionFormatedValue: Array<Form> = [];

		// Icons
		closeIcon = mdiClose;
		addIcon = mdiPlus;

		created() {
			this.formatValueToCollectionValue();
		}

		mounted() {
			if (0 === this.collectionFormatedValue.length) {
				this.formatValueToCollectionValue();
			}
		}

		getItemLabel(index: number) {
			return `${this.label} ${index + 1}`;
		}

		getItemRef(index: number) {
			return `collectionTypeFormItem-${index + 1}`;
		}

		formatValueToCollectionValue() {
			this.value.forEach((item, index) => {
				this.collectionFormatedValue[index] = this.getModelByCollectionsItem(item);
			});
		}

		getModelByCollectionsItem(item: any) {
			return Object.fromEntries(
				Object.entries(this.collectionForm).map(([key, entry]) => [
					key,
					{ ...entry, value: this.formatDataValue(item[key], entry) }
				])
			);
		}
		applyErrors(index: number) {
			const ref = this.$refs[this.getItemRef(index)] as
				| InstanceType<typeof CustomFormBuilder>
				| InstanceType<typeof CustomFormBuilder>[]
				| undefined;

			const component = Array.isArray(ref) ? ref[0] : ref;

			const errors = this.apiErrors?.[this.formName];

			if (component && errors?.children[index]) {
				component.setErrorsFromApi(errors.children[index]);
			}
		}
		updatePropsValue() {
			const newValue: Array<any> = [];

			this.collectionFormatedValue.forEach((item, index) => {
				newValue[index] = getFormValue(item);
				newValue[index].formRef = this.$refs[this.getItemRef(index)];

				if (this.value[index] && this.value[index].hasOwnProperty('id')) {
					newValue[index].id = this.value[index].id;
				}
			});

			this.$emit('update-value', newValue);
			this.$emit('change', newValue);
		}

		addItemToCollection() {
			const newItemValues = this.formatValue(this.collectionForm, true);

			this.collectionFormatedValue.push(this.getModelByCollectionsItem(newItemValues));
			this.updatePropsValue();
		}

		deleteItemFromCollection(index: number) {
			const newValue = this.value;
			if (newValue[index]) {
				newValue.splice(index, 1);
				this.collectionFormatedValue.splice(index, 1);
			}

			this.updatePropsValue();
		}

		formatValue(formValues: Form, resetValue?: boolean) {
			return Object.fromEntries(
				Object.entries(formValues).map(([key, element]) => (
					[
						key,
						resetValue ? '' : this.formatDataValue(element.value, element)
					]
				))
			);
		}

		formatDataValue(newValue: any, entry: any) {
			if ('date' === entry.type) {
				return formatDate(newValue);
			}

			return newValue;
		}
	}
